/**
 * Created by Thomas Mark
 * Date: 2019-10-29
 * 
 * Fortschrittsanzeige mit Welcome, Logo und bigImage
 *
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Logo from "./Logo";
import Welcome from "./Welcome";

import * as utils from "../../basics/utils"
import * as appActions from "../../store/actions/appActions";
import * as syncActions from "../../store/actions/syncActions";

class ProgressView extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    render() {
        const { windowWidth, headerHeight, inputHeight, currentContainer, orientation } = this.props.app;
        const { syncType } = this.props.sync;

        if (syncType === '') return null;

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        /**
         * Downloadblende, die während der Dauer des Downloads angezeigt wird.
         */
        const renderProgressView = () => {
            if (syncType === '') return null;

            const container = utils.getContainer(currentContainer);

            const renderBigImage = () => {

                const onClick = (e) => {
                    var isAlt = (e.altKey && !e.shiftKey && !e.ctrlKey);
                    if (isAlt && syncType !== '') {
                        this.props.setSyncAdmin(true); // syncAction.js
                    }
                }

                const style = {
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'cover',
                    ...utils.getStyleBackgroundImageBase64('data:image/png;base64,' + container.base64),
                }

                return (
                    <div className="w-full h-full flex" style={style} onClick={onClick}></div>
                )
            }

            const style = {
                height: (inputHeight + headerHeight) + 'px',
                minHeight: (inputHeight + headerHeight) + 'px',
                backgroundColor: 'rgb(145,28,33)'
            };

            if (orientation === 'landscape') {
                return (
                    <div className="SyncView w-full h-full flex flex-col text-white ">
                        <div className="w-full h-full flex" style={style}>
                            <div className="w-1/2 h-full flex" >
                                {renderBigImage()}
                            </div>
                            <div className="w-1/2 h-full flex flex-col" >
                                <div className="w-full h-full flex flex-col px-4 pb-4" >
                                    <Logo width={windowWidth * .75} version={true} />
                                    <div className="w-full">
                                        <Welcome width={windowWidth * .75} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            else // portrait
            {
                return (
                    <div className="SyncView w-full h-full flex flex-col text-white ">
                        <div className="w-full h-full flex flex-col" style={style}>
                            <div className="w-full flex" style={{ height: '74%' }}>
                                {renderBigImage()}
                            </div>
                            <div className="w-full flex" style={{ height: '26%' }}>
                                <div className="w-6/12 flex" >
                                </div>
                                <div className="w-6/12 flex flex-col px-4 pb-4">
                                    <Logo width={windowWidth * .75} version={true} />
                                    <div className="w-full">
                                        <Welcome width={windowWidth * .75} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        return (
            <div className="absolute w-full h-full text-white" >
                {renderProgressView()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        sync: state.sync
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, syncActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgressView);
